(function () {
  var replacement = '<strong>Oversized slab delivery</strong>Slabs are oversized and require special handling. Local pickup is available in Anaheim. For delivery, contact us for a custom freight quote before ordering.';

  function updateSlabNotices() {
    var notices = document.querySelectorAll('.encore-slab-purchase-notice');
    notices.forEach(function (notice) {
      if (notice.innerHTML !== replacement) {
        notice.innerHTML = replacement;
      }
    });
    return notices.length > 0;
  }

  function watchForSlabNotice() {
    var observer = new MutationObserver(function () {
      updateSlabNotices();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    updateSlabNotices();
    window.setTimeout(function () { observer.disconnect(); }, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForSlabNotice);
  } else {
    watchForSlabNotice();
  }
}());

